"use client";

import parseUserAgent from "@workspace/nextjs_utils/src/parseUserAgent";
import { useInView } from "react-hook-inview";

type Props = {
  minHeight?: number | string;
  gridArea?: string;
  placeholder?: React.JSX.Element;
};

const Lazy: FC<Props> = ({ minHeight, gridArea, placeholder, children }) => {
  const [ref, isVisible] = useInView({ unobserveOnEnter: true });

  const { isCrawler } = parseUserAgent(global?.navigator?.userAgent);

  if (isCrawler) {
    return children;
  }

  return (
    <div
      ref={ref}
      style={{ minHeight, gridArea }}
      className={isVisible ? "lazyContainer" : ""}
    >
      {isVisible ? children : placeholder}
    </div>
  );
};

export default Lazy;
